import Icon from '../components/Icon.vue'

Icon.register({"hand-peace":{"width":448,"height":512,"paths":[{"d":"M408 216C385.9 216 368 233.9 368 256H360V224C360 201.9 342.1 184 320 184S280 201.9 280 224V256H272V48C272 21.5 250.5 0 224 0S176 21.5 176 48V256H162.4L92.7 78.4C83 53.8 55.1 41.6 30.5 51.3 5.8 61-6.4 88.9 3.3 113.6L78.1 303.9 47 328.8C31.6 341.1 27.5 362.7 37.3 379.8L101.3 491.8A40-40 0 0 1 136 512H376C394.6 512 410.7 499.2 414.9 481.2L446.9 345.2A40-40 0 0 1 448 336V256C448 233.9 430.1 216 408 216z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-peace.js
// module id = null
// module chunks = 